const stars = document.querySelectorAll('[data-rate]')

if (stars.length > 0) {
  import(/* webpackChunkName: "holy-stars" */ 'holy-stars').then(
    ({ HolyStars }) => {
      stars.forEach((rateElement) => {
        const rateValue = rateElement.dataset.rate
        new HolyStars({
          el: rateElement,
          rate: rateValue,
          size: 20,
          primaryColor: rateElement.dataset.primaryColor || '#000',
          secondColor: rateElement.dataset.secondColor || '#dadada'
        })
      })
    }
  )
}
